// Variante VISUELLE du saut trampoline (18/07, retour Claude-Alain : « implémente les 4 sauts
// pour qu'ils soient de manière aléatoire ») : un tirage PAR REBOND, déterministe depuis l'état
// partagé — le tick de l'événement `bounce` (unique par rebond) + l'index du coureur — donc
// identique sur tous les clients et en rejeu ; JAMAIS de Math.random côté rendu.
// La mécanique (montée 2 su/tick, 3 ou 5 cases) et le « boing » ne varient jamais : seul
// l'HABILLAGE de la montée change. Testé par tests/tramp-variantes.test.ts.
export type BounceVariant = 0 | 1 | 2 | 3 // 0 physique · 1 acrobate · 2 cartoon · 3 propulseur

export function bounceVariant(bounceAt: number, idx: number): BounceVariant {
  let h = (Math.imul(bounceAt, 2246822519) + idx * 68219 + 11) >>> 0
  h = (h ^ (h >>> 13)) >>> 0
  h = Math.imul(h, 1274126177) >>> 0
  return ((h >>> 8) % 4) as BounceVariant
}

// Pose du coureur pendant la fenêtre du rebond (PURE -> testable, drawRunner reste mince).
// elapsed = ticks depuis l'événement bounce ; riseTicks = durée de montée (total/2 : 12 ou 20).
// - squash : écrasé sur la toile (2 ticks ; le cartoon tient la crêpe 4 ticks) ;
// - launch : éjection bras au ciel, toute la montée ;
// - vrille : même pose mais le RENDU la fait tourner sur 360° (cartoon) ;
// - apex   : suspension au sommet (acrobate) — déborde 3 ticks sur la chute (falling requis
//   après la montée : si le coureur atterrit direct sur une corniche, on rend la main net).
export type BouncePose = 'squash' | 'launch' | 'vrille' | 'apex' | null

export function bouncePose(bv: BounceVariant, elapsed: number, riseTicks: number, falling: boolean): BouncePose {
  if (elapsed < 0) return null
  const squash = bv === 2 ? 4 : 2
  if (elapsed < squash) return 'squash'
  if (bv === 1 && elapsed >= riseTicks - 2) {
    if (elapsed < riseTicks) return 'apex'
    return elapsed < riseTicks + 3 && falling ? 'apex' : null
  }
  if (elapsed < riseTicks) return bv === 2 ? 'vrille' : 'launch'
  return null
}
